import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/** Listado de semanas operativas para el selector del reporte. */
export function useSemanas() {
  return useQuery({
    queryKey: ['semanas', 'lista'],
    queryFn: () => cliente.semanas.listar(),
    staleTime: 60_000,
  });
}

/** Reporte semanal (Producción + datos para Mano de Obra/Matriz futuros).
 * `venta` filtra las obras por estado de venta (formalizadas / no formalizadas). */
export function useReporteSemanal(
  semanaId: number | null,
  venta: 'todas' | 'formalizadas' | 'no_formalizadas' = 'todas',
) {
  return useQuery({
    queryKey: ['reporte-semanal', semanaId, venta],
    enabled: semanaId != null,
    queryFn: () => cliente.reportes.semanal(semanaId as number, venta),
    staleTime: 30_000,
  });
}

/** Histórico (grilla sub-partida × obra) para una semana — vistas Por Sprint /
 * Por Partida / Kanban. */
export function useHistorico(semanaId: number | null) {
  return useQuery({
    queryKey: ['reporte-historico', semanaId],
    enabled: semanaId != null,
    queryFn: () => cliente.reportes.historico(semanaId as number),
    staleTime: 30_000,
  });
}

/** m² producidos por partida / sub-partida (semana + acumulado) para una semana. */
export function useM2(semanaId: number | null) {
  return useQuery({
    queryKey: ['reporte-m2', semanaId],
    enabled: semanaId != null,
    queryFn: () => cliente.reportes.m2(semanaId as number),
    staleTime: 30_000,
  });
}

/** Drill-down de una obra: sub-partidas que avanzaron esta semana (% / m² / ₡). */
export function useObraAvance(semanaId: number | null, obra: string | null) {
  return useQuery({
    queryKey: ['reporte-obra-avance', semanaId, obra],
    enabled: semanaId != null && obra != null,
    queryFn: () => cliente.reportes.obraAvance(semanaId as number, obra as string),
    staleTime: 30_000,
  });
}

/** Pendientes arrastrados (estado vivo) — sub-partidas de sprints previos sin completar. */
export function usePendientes() {
  return useQuery({
    queryKey: ['reporte-pendientes'],
    queryFn: () => cliente.reportes.pendientes(),
    staleTime: 30_000,
  });
}

/** Avance de un mes ('YYYY-MM') por obra y sub-partida — análisis mensual. */
export function useMesAvance(mes: string | null) {
  return useQuery({
    queryKey: ['reporte-mes', mes],
    enabled: mes != null,
    queryFn: () => cliente.reportes.mes(mes as string),
    staleTime: 60_000,
  });
}
